<script lang="ts">
	import { storeCartItems, storeMiniCartModal } from '$lib/js/stores'
	import { PUBLIC_MAGENTO_ENDPOINT } from '$env/static/public'
	import {
		getProductFinalPrice,
		getProductFinalPriceWithTax,
		is_set_array,
		isSequraActive,
		truncateNumber,
	} from '$lib/js/helpers'
	import { t } from 'svelte-i18n-lingui'
	import { page } from '$app/stores'
	import { getContextScope } from '$lib/js/helpers/i18n'

	export let type = ''

	const scope = getContextScope()

	let cartSubtotals = 0
	let cartWithoutTaxes = 0

	/** Load the checkout page. */
	function proceedToCart() {
		if (typeof window != 'undefined') {
			window.location.href = `${PUBLIC_MAGENTO_ENDPOINT}/${scope}/checkout`
		}
	}

	$: if (is_set_array($storeCartItems)) {
		cartSubtotals = 0
		cartWithoutTaxes = 0

		for (const i in $storeCartItems) {
			cartSubtotals += getProductFinalPriceWithTax($storeCartItems[i]) * $storeCartItems[i].cart_qty
			cartWithoutTaxes += getProductFinalPrice($storeCartItems[i]) * $storeCartItems[i].cart_qty
		}
	} else {
		cartSubtotals = 0
		cartWithoutTaxes = 0
	}

	$: progress = (truncateNumber(cartSubtotals, 2) * 10) / 7
</script>

<div class="cart-totals {type}">
	{#if type === ''}
		<h2 class="title">{$t`Purchase resume`}</h2>
	{/if}
	<div class="cart-totals__inner">
		{#if type === 'minicart'}
			<button class="continue-buying" on:click={() => ($storeMiniCartModal = false)}
				>{$t`Continue buying`}</button
			>
		{/if}

		<div class="cart-totals__totals">
			{#if type === 'minicart' && cartSubtotals < 69}
				<div class="free-shipping">
					<span style="width: {progress}%" />
					<p>{$t`${(69 - cartSubtotals).toFixed(2)}€ missing for free shipping!`}</p>
				</div>
			{:else if type === 'minicart' && cartSubtotals >= 69}
				<div class="free-shipping full">
					<p><b>{$t`Congrats, your shipping is free!`}</b></p>
				</div>
			{/if}

			<table>
				{#if type !== 'minicart'}
					<tr class="subtotal">
						<th>{$t`Subtotal`}</th>
						<th>{cartSubtotals.toFixed(2)}€</th>
					</tr>
					<tr class="tax">
						<th>{$t`VAT (included)`}</th>
						<th>{(cartSubtotals - cartWithoutTaxes).toFixed(2)}€</th>
					</tr>
				{/if}

				<tr class="total">
					<th>{$t`Total (TAX incl.)`}</th>
					<th>{cartSubtotals.toFixed(2)}€</th>
				</tr>
			</table>

			<button class="u-btn" on:click={() => proceedToCart()}>{$t`Proceed to payment`}</button>

			{#if type !== 'minicart' && isSequraActive($page.data?.settings)}
				<div class="sequra">
					<div
						class="sequra-promotion-widget"
						data-amount={cartSubtotals.toFixed(2)}
						data-product="pp3"
						data-size="S"
						data-branding="black"
					/>
				</div>

				<span
					class="sequra-educational-popup"
					data-amount={cartSubtotals.toFixed(2)}
					data-product="pp3"
				/>
			{/if}
		</div>
	</div>
</div>

<style lang="scss">
	.sequra {
		margin-top: 20px;
	}

	.free-shipping {
		position: relative;
		text-align: center;
		padding: 10px 25px;
		background: #ffe5df;
		margin: 0 -25px 10px;

		p {
			position: relative;
		}

		span {
			position: absolute;
			top: 0;
			left: 0;
			bottom: 0;
			background: #ff420030;
		}

		&.full {
			background: var(--secondary);
			color: white;
		}
	}

	.cart-totals {
		h2.title {
			padding-bottom: 10px;
			border-bottom: 1px solid var(--grey--b);
			font-size: 22px;
		}

		&.minicart {
			table {
				margin-bottom: 12px;

				tr {
					&.total {
						th {
							border-top: none;
							padding: 0 0 10px;
						}
					}
				}
			}
		}
	}

	button.continue-buying {
		display: block;
		text-align: center;
		padding: 10px;
		margin-bottom: 15px;
		width: 100%;
	}

	button.u-btn {
		width: 100%;
		font-size: 16px;
	}

	table {
		width: 100%;
		border: 0;
		border-collapse: collapse;

		tr {
			&.total {
				th {
					border-top: 1px solid #d9d9d9;
					padding: 10px 0;
				}
			}

			&.tax {
				th {
					padding-bottom: 10px;
				}
			}

			&.tax,
			&.subtotal {
				th:last-child {
					font-size: 16px;
					font-weight: 400;
				}
			}
		}

		th {
			text-align: left;
			font-weight: 400;
			padding: 2px 0;

			&:last-child {
				text-align: right;
				font-weight: 700;
				font-size: 20px;
			}
		}
	}
</style>
